import React, { useState } from "react";
import * as AccountLinkServices from "../../../../services/AccountLinkService";
import PaginateList from "../../../utils/PaginateList";
import { useTranslation } from "react-i18next";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { formatearNumero } from "../../../../utils/formats/index";
import { Row, Col, Th } from "./accountLineList.styled";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";

const AccountLinkListContainer = ({ data, onCancel }) => {
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const renderLines = () => {
    return data.lines.map((line, index) => {
      return (
        <Row className="row" key={index}>
          <Col className="col" $first>
            {line.name}
          </Col>
          <Col className="col" $withMin>
            {line.document}
          </Col>
          <Col className="col">{line.account}</Col>
          <Col className="col" $withMin>
            {line.type}
          </Col>
          <Col className="col">{formatearNumero(line.value, 0)}</Col>
          <Col className="col-4">{line.description}</Col>
          <Col className="col">{line.client}</Col>
          <Col className="col">{line.costCenter}</Col>
          <Col className="col">{line.society}</Col>
        </Row>
      );
    });
  };
  return (
    <>
      <div className="row align-items-center justify-content-center mb-2">
        <div className="col-11">
          <h3 className="title">{t("forms.accountLink.data")}</h3>
        </div>
      </div>
      <div className="row align-items-center justify-content-center mb-4">
        <div className="col-11">
          <div className="row">
            <div className="col-11">
              {t("forms.accountLink.labels.company")}:{" "}
              <strong>{data.company}</strong>
            </div>
          </div>
          <div className="row">
            <div className="col-11">
              {t("forms.accountLink.labels.period")}:{" "}
              <strong>{`${data.month}/${data.year}`}</strong>
            </div>
          </div>
          <div className="row">
            <div className="col-11">
              {t("forms.accountLink.labels.doc")}:{" "}
              <strong>{`${data.order}`}</strong>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-center justify-content-center">
        <div className="col-11">
          <Th className="row" $first>
            <Col className="col" $first $isHead>
              {t("forms.accountLink.labels.account")}
            </Col>
            <Col className="col" $withMin $isHead>
              {t("forms.accountLink.labels.doc2")}
            </Col>
            <Col className="col" $isHead>
              {t("forms.accountLink.labels.conta")}
            </Col>
            <Col className="col" $withMin $isHead>
              {t("forms.accountLink.labels.n")}
            </Col>
            <Col className="col" $isHead>
              {t("forms.accountLink.labels.value")}
            </Col>
            <Col className="col-4" $isHead>
              {t("forms.accountLink.labels.desc")}
            </Col>
            <Col className="col" $isHead>
              {t("forms.accountLink.labels.entity")}
            </Col>
            <Col className="col" $isHead>
              {t("forms.accountLink.labels.cc")}
            </Col>
            <Col className="col" $isHead>
              {t("forms.accountLink.labels.soc")}
            </Col>
          </Th>
        </div>
      </div>
      <div className="row align-items-center justify-content-center mb-3">
        <div className="col-11">{renderLines()}</div>
      </div>
    </>
  );
};

export default AccountLinkListContainer;
